import { render, staticRenderFns } from "./CompetitorPerson.vue?vue&type=template&id=7e093beb&scoped=true"
import script from "./CompetitorPerson.vue?vue&type=script&lang=js"
export * from "./CompetitorPerson.vue?vue&type=script&lang=js"
import style0 from "./CompetitorPerson.vue?vue&type=style&index=0&id=7e093beb&prod&scoped=true&lang=css"
import style1 from "./CompetitorPerson.vue?vue&type=style&index=1&id=7e093beb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e093beb",
  null
  
)

export default component.exports